import { render, staticRenderFns } from "./SearchBarHeader.vue?vue&type=template&id=1f9a7b7a&scoped=true"
import script from "./SearchBarHeader.vue?vue&type=script&lang=js"
export * from "./SearchBarHeader.vue?vue&type=script&lang=js"
import style0 from "./SearchBarHeader.vue?vue&type=style&index=0&id=1f9a7b7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9a7b7a",
  null
  
)

export default component.exports